<template>
  <div class="search-bar">
    <svg slot="prefix" svg-inline="" @click="onSearch" focusable="false" role="presentation" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="24" height="24"><defs><path id="ic_searchbar_darkgray_svg__a" d="M15.1797038 13.7571474l4.7528058 4.7726378-1.4142135 1.4142135-4.7518254-4.7716533C12.3184422 16.3168321 10.4890023 17 8.5 17 3.8055796 17 0 13.1944204 0 8.5S3.8055796 0 8.5 0 17 3.8055796 17 8.5c0 1.9847359-.6802402 3.8105932-1.8202962 5.2571474zM8.5 15c3.5898509 0 6.5-2.9101491 6.5-6.5S12.0898509 2 8.5 2 2 4.9101491 2 8.5 4.9101491 15 8.5 15z"/></defs><g fill="none" fill-rule="evenodd" transform="translate(2 2)"><mask id="ic_searchbar_darkgray_svg__b" fill="#fff"><use xlink:href="#ic_searchbar_darkgray_svg__a"/></mask><use fill="#9A9A9A" fill-rule="nonzero" xlink:href="#ic_searchbar_darkgray_svg__a"/><g fill="#111" mask="url(#ic_searchbar_darkgray_svg__b)"><path d="M-2-2h24v24H-2z"/></g></g></svg>
    <el-autocomplete
      ref="search_bar"
      v-model="inputQuery"
      :fetch-suggestions="loadTypeAhead"
      :trigger-on-focus="trigger_on_focus"
      :debounce="debounce_delay"
      :popper-append-to-body="false"
      :hide-loading="true"
      placement="bottom-end"
      placeholder="Podcast, genre, host, topic..."
      popper-class="search-autocomplete"
      @select="onAutoCompSelect"
      @keyup.native="checkInput">
      <template
        slot-scope="{item}"
        class="text-dark">
        <p
          v-if="item.suggestion && item.suggestion !== no_recent_searches"
          :class="{'text-blue' : item.recent_search}"
          class="value">{{ item.suggestion }}</p>
        <a
          v-if="item.recent_search"
          @click="removeRecentSearch(item.suggestion)">Remove</a>
        <p
          v-if="item.clear_all && recent_searches.length"
          class="clear_all t-l"
          @click="clearAllRecentSearches">Clear Recent Searches</p>
      </template>
    </el-autocomplete>
    <span
      v-show="inputQuery"
      @click="clearInputBar"><i
        :class="`${suggestions_loading ? 'el-icon-loading' : 'fa fa-times'}`"/></span>
  </div>
</template>

<script>
import * as log from 'loglevel';
import Search from '../services/Search';
import PlayerEvent from '../services/PlayerEvent';
import Loader from './Loader';

export default {
  name: 'SearchBarComponent',
  components: { Loader },
  props: {
    query: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      typeahead_result: [],
      recent_searches: [],
      searchProvider: new Search(),
      playerEvent: new PlayerEvent(),
      suggestions_loading: false,
      inputQuery: '',
      typedQuery: null,
      no_suggestions_text: 'No results found. Try another search.',
      no_recent_searches: "You haven't searched anything recently!",
      limit_suggestions: 20,
      show_more_suggestions: true,
      previous_length: 0,
      limit_reached: false,
      debounce_delay: 300,
      select_autocomplete: true,
      trigger_on_focus: true,
      isLoggedIn: this.$store.getters.loggedIn,
    };
  },
  watch: {
    inputQuery() {
      if (!this.inputQuery) {
        this.clearInputBar();
      }
    },
    suggestions_loading() {
      if (this.suggestions_loading) {
        document.querySelector('.search-autocomplete').classList.add('d-none');
      } else {
        document.querySelector('.search-autocomplete').classList.remove('d-none');
      }
    },
  },
  beforeMount() {
    if (!this.isLoggedIn) return;
    this.recent_searches = this.getRecentSearchesVueX();
    this.getRecentSearchesApiCall()
      .then((res) => {
        this.recent_searches = res;
        this.$store.dispatch('setRecentSearches', res);
      })
      .catch((err) => {
        log.info(err);
      });
  },
  mounted() {
    this.inputQuery = this.$route.query.q || '';
  },
  methods: {
    focusOnInput() {
      this.$refs.search_bar.focus();
    },
    checkInput(event) {
      if (event.keyCode === 13) this.onSearch();
      else this.typeahead_result = [];
    },
    loadTypeAhead(query, cb) {
      // Load recent searches when user clicks on search bar and no text is present in it.
      if (this.isNullOrWhiteSpace(this.inputQuery)) {
        if (!this.isLoggedIn) {
          cb([]);
          return;
        }
        cb(this.recent_searches);
        return;
      }
      if (this.inputQuery.length < 3) {
        cb([]);
        return;
      }
      if (this.typeahead_result.length) return;
      this.suggestions_loading = true;
      this.typeAheadApiCall()
        .then((res) => {
          this.typeahead_result = res;
          cb(res);
        })
        .catch((err) => { log.info(err && err.message); })
        .then(() => { this.suggestions_loading = false; });
    },
    typeAheadApiCall() {
      return new Promise((resolve, reject) => {
        this.typeahead_result = [];
        let tempArr = [];
        this.typedQuery = this.inputQuery;
        // To prevent back-end error. Invalid character 'x' in string escape code
        if (this.inputQuery.search(/<|>/g) !== -1) {
          resolve([{ suggestion: this.no_suggestions_text }]);
          return;
        }
        this.searchProvider.typeAheadSearch(this.inputQuery, this.limit_suggestions)
          .then((res) => {
            tempArr = (res && res.suggestions) || [];
            // tempArr = tempArr
            //   .map(item => ({
            //     ...item,
            //     recent_search: this.recent_searches.some(elem => (elem && elem.suggestion && elem.suggestion.toLowerCase()) === (item && item.suggestion && item.suggestion.toLowerCase())),
            //   }));
            if (tempArr.length) {
              tempArr
                .unshift({
                  clear_all: tempArr.some(item => item.recent_search),
                });
            } else {
              tempArr
                .unshift({
                  suggestion: this.no_suggestions_text,
                });
            }
            resolve(tempArr);
          })
          .catch((error) => {
            reject(error && error.message);
            this.suggestions_loading = false;
            this.showErrorMsg('Luminary is experiencing issues running this search. Try again later.');
          });
      });
    },
    onAutoCompSelect(item) {
      let itemIndex = null;
      let searchVariant = null;
      if (!item.recent_search) {
        itemIndex = this.typeahead_result.findIndex(nextItem => item.suggestion === nextItem.suggestion);
        const bucket = { name: 'Typeahead' };
        const bucketItem = { title: item.suggestion, beacon_id: item.beacon_id, item_position: itemIndex };
        this.playerEvent.triggerContentSelectEvent(bucket, bucketItem);
        searchVariant = 'auto_complete';
      } else {
        itemIndex = this.recent_searches.findIndex(nextItem => item.suggestion === nextItem.suggestion);
        searchVariant = 'recent_search';
      }

      if (item.suggestion === this.no_suggestions_text || item.suggestion === this.no_recent_searches || item.clear_all) return;

      if (!this.select_autocomplete || !item || !item.suggestion) return;

      this.inputQuery = item.suggestion;
      if (!this.inputQuery) {
        this.displayEmptySearchBarMsg();
        return;
      }
      this.emitSearchEvent();

      if (this.isLoggedIn) this.saveEnteredSearch();
      else log.warn('Not Logged in.');

      this.triggerSearchInitiatedEvent(searchVariant, itemIndex);
    },
    displayEmptySearchBarMsg() {
      this.showErrorMsg('Search cannot be empty!');
    },
    emitSearchEvent() {
      this.$emit('onSearch', this.inputQuery);
    },
    clearInputBar() {
      this.inputQuery = '';
      this.typeahead_result = [];
      this.$emit('clearSearch', 1);
    },
    saveEnteredSearch() {
      if (!this.inputQuery) return;
      const arr = this.$store.getters.search_data;
      if (arr.findIndex(item => item === this.inputQuery) === -1) {
        arr.unshift(this.inputQuery);
      }
      this.$store.dispatch('setRecentSearches', arr);
      this.searchProvider.saveRecentSearch(this.inputQuery)
        .then(() => {
          log.info('Recent search Saved');
        })
        .catch((error) => {
          log.warn(error.message);
        });
    },
    getRecentSearchesVueX() {
      return this.$store.getters.search_data || [];
    },
    getRecentSearchesApiCall() {
      return new Promise((resolve, reject) => {
        if (!this.isLoggedIn) {
          resolve([]);
        }
        this.searchProvider.getRecentSearches()
          .then((res) => {
            let tempArr = res;
            if (!tempArr || !tempArr.length) resolve([]);
            tempArr = tempArr.map(item => ({
              suggestion: item.keyword,
              recent_search: true,
            }));
            tempArr.unshift({
              suggestion: '',
              recent_search: false,
              clear_all: true,
            });
            resolve(tempArr);
          })
          .catch((err) => {
            reject(err);
            // log.info('Could not fetch recent searches');
            // log.info(err);
          });
      });
    },
    removeRecentSearch(text) {
      this.select_autocomplete = false;
      // console.log(this.recent_searches);
      this.recent_searches.splice(this.recent_searches.findIndex(elem => elem.suggestion === text), 1);
      const tempArr = this.recent_searches;
      tempArr.filter(item => item.clear_all && !item.recent_search);
      // console.log(tempArr);
      // const tempArr = this.$store.getters.search_data;
      // tempArr.splice(tempArr.findIndex(elem => elem === text), 1);
      this.$store.dispatch('setRecentSearches', tempArr);

      this.searchProvider.deleteRecentSearch(text)
        .then((res) => {
          if (res && res.success) {
            log.info('Recent Search Deleted..');
            this.triggerSearchItemClearedEvent(text);
          } else {
            log.warn('Recent Search Not Deleted..');
          }
          this.select_autocomplete = true;
        })
        .catch((error) => {
          log.warn('Recent Search Not Deleted..');
          this.select_autocomplete = true;
          log.warn(error.message);
        });
    },
    clearAllRecentSearches() {
      this.recent_searches = [];
      this.$store.dispatch('delRecentSearches');
      this.searchProvider.deleteAllRecentSearches()
        .then((res) => {
          if (res && res.success) {
            this.showSuccessMsg('Recent searches cleared!');
            this.triggerSearchAllClearedEvent();
          } else log.warn('Recent searches not cleared');
        })
        .catch((error) => {
          log.warn(error.message);
        });
    },
    onSearch() {
      log.info(`Search Query: ${this.inputQuery}`);
      if (this.isNullOrWhiteSpace(this.inputQuery)) {
        this.displayEmptySearchBarMsg();
        return;
      }
      this.emitSearchEvent();
      if (this.isLoggedIn) this.saveEnteredSearch();

      this.triggerSearchInitiatedEvent('return', null);
    },
    triggerSearchInitiatedEvent(searchVariant, autoCompletePos) {
      if (autoCompletePos > -1) {
        autoCompletePos -= 1; // autocomplete list has Clear Searches item at zero index
      }
      const data = {
        screen_name: window.Vue.$route.name,
        autocomplete_position_selected: autoCompletePos,
        search_query: this.inputQuery,
        search_variant: searchVariant,
        typed_query: this.typedQuery,
      };
      this.$analytics.track('Search Initiated', data);
    },
    triggerSearchAllClearedEvent() {
      this.$analytics.track('Search All Cleared', { screen_name: window.Vue.$route.name });
    },
    triggerSearchItemClearedEvent(itemText) {
      this.$analytics.track('Search Item Cleared', { screen_name: window.Vue.$route.name, item_text: itemText });
    },
  },
};
</script>

<style lang="scss">
@import "../assets/scss/variables.scss";
.search-bar {
  width: 85%;
  max-width: 1076px;
  margin: 40px auto 44px;
  position: relative;
  img {
    position: absolute;
    z-index: 999;
    top: 20px;
    left: 20px;
    cursor: pointer;
  }
  ::placeholder {
    color:$light-gray !important;
    font-size: 20px !important;
    font-weight:300 !important;
    font-family: Favorit-Light;
  }
  .el-autocomplete{
    width: 100%;
  }
  .el-dropdown-menu__item{
    .el-tag {
      margin-top:8px;
      margin-left:15px;
    }
    a {
      float:right;
    }
    .load-more {
      text-align: center;
      margin:0 auto;
      text-decoration: underline;
      color:$gray;
      margin-top:15px;
      z-index: 9999;
      cursor: pointer;
    }
  }
  .el-dropdown-menu {
    background-color: #fff !important;
    .load-more {
      text-align: center;
      margin:0 auto;
      text-decoration: underline;
      color:$gray;
      margin-top:15px;
      cursor: pointer;
    }
  }
  .el-dropdown-menu__item:not(.is-disabled):hover,
  .el-dropdown-menu__item:focus{
    background-color:$black !important;
    color:#fff !important;
    .el-tag{
      color:#fff;
      background-color: transparent;
    }
  }

  svg {
    width: 32px;
    position: absolute;
    top: 49%;
    z-index:999;
    left: 12px;
    cursor: pointer;
    transform: translateY(-50%);
  }

  span {
    position: absolute;
    top: 17px;
    right: 20px;
    font-size: 1.5rem;
    color: $light-gray;
    cursor: pointer;
     i{
       font-weight: 700;
     }
  }

  .el-input__inner {
    padding: 0 1rem 0 3rem !important;
    height: 64px;
    font-size: 20px;
    font-weight: 500;
    border:1px solid $light-gray;
    border-radius: .6rem !important;
    outline:none !important;
    color:$black;
  }
  .el-input__inner:focus, .el-input__inner:active {
    border:1px solid #ccc;
    outline:none !important;
  }
  .el-input__inner:hover {
    border:1px solid $black;
    outline:none !important;
  }
  .el-autocomplete-suggestion__wrap {
    padding-bottom: 0 !important;
  }
}

@media (max-width: $lg) {
  .search-bar {
    max-width: 763px;
    width: 100%;
    img {
      top: 16px;
    }
  }
}

@media (max-width: $xs) {
  .search-bar {
    ::placeholder {
      font-size: 16px !important;
    }
    img {
      width:24px;
      left: 10px;
      top: 14px;
      cursor: pointer;
    }
    span {
      position: absolute;
      top:1.6rem;
      right:0;
      font-size: 1.2rem;
      padding: 0 15px;
      color:$light-gray;
      cursor: pointer;
      i {
        font-weight: 700;
      }
    }
    .el-input__inner {
      padding:1.75rem 0 1.75rem 3rem !important;
    }
  }
}
</style>



// WEBPACK FOOTER //
// app/src/components/SearchBar.vue